<template>
  <div class="columns is-multiline">
    <div class="column is-narrow pdr-0">
      <b-field expanded>
        <b-select class="is-min-width-240" :placeholder="placeholder" v-model="action"
          expanded :disabled="disabled">
          <option :value=null></option>
          <option v-for='option in options' :key='option.action' :value="option.action">
            {{ $t(option.translation) }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column">
      <button
        @click="handleAction"
        :class="{ 'button-access-no-permission' : !actionsGroupeesEnabled }"
        :disabled='!actionsGroupeesEnabled || disabled'
        class="button is-primary">
        {{ $t(titleButton) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelecteurAction',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    elementsSelectionnes: {
      type: Boolean,
      required: true,
    },
    titleButton: {
      type: String,
      required: true,
    },
    options: {
      required: true,
      default: () => [],
      validator(value) {
        return Array.isArray(value) && value.every(v => {
          return v.action && v.translation;
        });
      },
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      action: null,
    };
  },
  methods: {
    handleAction() {
      this.$emit('handleAction', this.action);
      this.action = null;
    },
  },
  computed: {
    actionsGroupeesEnabled() {
      return !!this.action && !!this.elementsSelectionnes;
    },
  },
};

</script>
